import { render } from "./DbsParkInfoLower.vue?vue&type=template&id=636f7912&scoped=true"
import script from "./DbsParkInfoLower.vue?vue&type=script&lang=js"
export * from "./DbsParkInfoLower.vue?vue&type=script&lang=js"

import "./DbsParkInfoLower.vue?vue&type=style&index=0&id=636f7912&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-636f7912"

export default script